module.exports = __webpack_public_path__ + "static/media/Larvitar_gaussian2.a579e77d.png";